import React, { useEffect, useState, useContext } from 'react';
import { Card, Dropdown } from 'react-bootstrap';
import CardDropdown from 'components/common/CardDropdown';
import { Link, useParams } from 'react-router-dom';
import OrdersTableHeader from './OrdersTableHeader';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import { useTranslation } from 'react-i18next';
import useOrderHook from 'y4/hooks/useOrderHook';
import y from 'y4/Utils';
import OrderStatus from '../OrderStatus';
import { ProductContext } from 'context/Context';

const Orders = () => {
  const { t } = useTranslation('commerce');
  const {
    productsState: {
      config: { currency }
    }
  } = useContext(ProductContext);

  const params = useParams();
  const columns = [
    {
      accessor: 'name',
      Header: t('Order'),
      headerProps: { className: 'pe-1' },
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { id, date, addressName, addressStreet, addressPhone } =
          rowData.row.original;
        return (
          <>
            <Link to={`/${params.corp}/e-commerce/orders/order-details/${id}`}>
              <strong>{id}</strong>
              <p className="d-md-block d-lg-none">
                {date}
                <br />
                {addressStreet}
                <br />
                <strong>{addressName}</strong> {addressPhone}
              </p>
            </Link>
          </>
        );
      }
    },
    {
      accessor: 'date',
      Header: t('Date'),
      headerProps: { className: 'd-none d-lg-table-cell' },
      cellProps: { className: 'd-none d-lg-table-cell' }
    },
    {
      accessor: 'address',
      Header: t('Ship To'),
      headerProps: { className: 'd-none d-lg-table-cell' },
      cellProps: { className: 'd-none d-lg-table-cell' },
      Cell: rowData => {
        const { addressName, addressStreet, addressPhone } =
          rowData.row.original;
        return (
          <>
            {addressStreet}
            <p className="mb-0 text-500">
              <strong>{addressName}</strong> {addressPhone}
            </p>
          </>
        );
      }
    },
    {
      accessor: 'status',
      Header: t('Status'),
      headerProps: {
        className: 'text-center d-none d-lg-table-cell'
      },
      cellProps: {
        className: 'fs-0 d-none d-lg-table-cell'
      },
      Cell: rowData => {
        const { status } = rowData.row.original;
        return <OrderStatus status={status} className={'d-block'} />;
      }
    },
    {
      accessor: 'amount',
      Header: t('Amount'),
      headerProps: {
        className: 'text-end d-none d-lg-table-cell'
      },
      cellProps: {
        className: 'text-end fs-0 fw-medium py-2 d-none d-lg-table-cell'
      },
      Cell: rowData => `${currency}${rowData.row.original.amount}`
    },
    {
      accessor: 'none',
      Header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      Cell: rowData => {
        const { status, amount } = rowData.row.original;

        return (
          <>
            <span className="d-md-block d-lg-none">
              <p>{`${currency}${amount}`}</p>
              <OrderStatus status={status} className={'d-block'} />
            </span>
            <CardDropdown iconClassName="fs--1">
              <div className="py-2">
                <Dropdown.Item
                  onClick={() => {
                    onComplete([rowData.row.id]);
                  }}
                >
                  {t('Completed')}
                </Dropdown.Item>
                <Dropdown.Divider as="div" />
                <Dropdown.Item
                  className="text-danger"
                  onClick={() => {
                    onDelete([rowData.row.id]);
                  }}
                >
                  {t('Delete')}
                </Dropdown.Item>
              </div>
            </CardDropdown>
          </>
        );
      }
    }
  ];

  const { loadOrders, deleteOrder, completeOrder } = useOrderHook();
  const [orderList, setOrderList] = useState([]);

  const refresh = () => {
    loadOrders().then(rt => {
      if (rt.isOk()) {
        setOrderList(rt.data.rows);
      } else {
        y.toastError(rt.message);
      }
    });
  };

  const onComplete = ids => {
    completeOrder(ids).then(rt => {
      if (rt.isOk()) {
        refresh();
        if (rt.message) {
          y.toastInfo(rt.message);
        }
      } else {
        y.toastError(rt.message);
      }
    });
  };
  const onDelete = ids => {
    deleteOrder(ids).then(rt => {
      if (rt.isOk()) {
        refresh();
        if (rt.message) {
          y.toastInfo(rt.message);
        }
      } else {
        y.toastError(rt.message);
      }
    });
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <AdvanceTableWrapper
      columns={columns}
      data={orderList}
      selection
      sortable
      pagination
      perPage={10}
    >
      <Card className="mb-3">
        <Card.Header>
          <OrdersTableHeader
            table
            onComplete={onComplete}
            onDelete={onDelete}
          />
        </Card.Header>
        <Card.Body className="p-0">
          <AdvanceTable
            table
            headerClassName="bg-200 text-900 text-nowrap align-middle"
            rowClassName="align-middle white-space-nowrap"
            tableProps={{
              size: 'sm',
              striped: true,
              className: 'fs--1 mb-0 overflow-hidden'
            }}
          />
        </Card.Body>
        <Card.Footer>
          <AdvanceTablePagination table />
        </Card.Footer>
      </Card>
    </AdvanceTableWrapper>
  );
};

export default Orders;
